import { Box } from "@mui/material";
import { colorLandingSurface, fontLandingSans } from "src/design/tokens";
import { HeroSection } from "./HeroSection";
import { EcosystemSection } from "./EcosystemSection";
import { FeaturesShowcaseSection } from "./FeaturesShowcaseSection";
import { AnalyticsSection } from "./AnalyticsSection";
import { ClientAppSection } from "./ClientAppSection";
import { StepsSection } from "./StepsSection";
import { PricingSection } from "./PricingSection";
import { FAQSection } from "./FAQSection";
import { DemoFormSection } from "./DemoFormSection";
import { useHashScroll } from "./useSectionNavigation";

/**
 * Public landing page. Section order tells the story: the two-channel promise,
 * the ecosystem loop, the feature tour, the data, the consumer app, onboarding,
 * pricing, objections, then the demo request.
 *
 * The header and footer are not rendered here: the app shell (App → Homepage)
 * already wraps every route with LandingHeader and LandingFooter.
 */
const LandingPage = () => {
  useHashScroll();

  return (
    <Box
      sx={{
        overflowX: "hidden",
        backgroundColor: colorLandingSurface,
        fontFamily: fontLandingSans,
        // Anchored sections must clear the sticky header instead of sliding
        // underneath it. Set once here rather than in every section.
        "& section[id]": { scrollMarginTop: "84px" },
      }}
    >
      <HeroSection />
      <EcosystemSection />
      <FeaturesShowcaseSection />
      <AnalyticsSection />
      <ClientAppSection />
      <StepsSection />
      <PricingSection />
      <FAQSection />
      <DemoFormSection />
    </Box>
  );
};

export default LandingPage;
